<template>
  <div class="notice-wrapper">
    <el-dropdown @command="noticeClick" placement="bottom-end">
      <div>
        <template v-if="isMiniScreen">
          <div class="el-dropdown-link">
            <i class="iconfont icon-gonggao-line"></i>
            <span class="msg_count">{{
              notice.length > 0 ? `(${notice.length})` : ""
            }}</span>
          </div>
        </template>
        <template v-else>
          <el-carousel
            class="carousel_box"
            indicator-position="none"
            arrow="never"
            height="48px"
          >
            <el-carousel-item
              v-for="item in notice"
              :key="item.id"
            >
              <p class="msg_content">{{ item.anns_title }}</p>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
      <el-dropdown-menu slot="dropdown" class="el-dropdown-menu-box">
        <el-dropdown-item v-for="item in notice" :key="item.id" :command="item" style="min-width: 168px;">
          {{ item.anns_title }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  name: "nav-notice",
  props: {
    isMiniScreen: {
      type: Boolean,
      default: false,
    },
    notice: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    noticeClick(notice) {
      this.$emit("noticeClick", notice);
    },
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>


// WEBPACK FOOTER //
// src/view/Home/header/navNotice/index.vue